import { ChevronDown } from 'lucide-react';

const Dropdown = ({ name, value, onChange, placeholder, options, disabled, empty }) => {
  const selectId = `select-${name}`;

  return (
    <div className="select-wrapper floating-label-wrapper">
      <select
        id={selectId}
        className="filter-base floating-select"
        name={name}
        value={value}
        onChange={onChange}
        disabled={disabled}
      >
        <option value="">{empty}</option>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      <label htmlFor={selectId} className="floating-label">
        {placeholder}
      </label>
      {/* <ChevronDown className="select-icon" size={16} /> */}
    </div>
  );
};

export default Dropdown;
